<template>
    <div>
        <div class="m-auto max-w-sm text-white pt-5 bg-content-fm h-full">
            <div class="">
                <img src="@/assets/default_main/ld_fm/logo_fastmoney_white.png" alt="logo fastmoney" />
            </div>
            <div class="text-2xl font-bold mt-2">
                Nhận tiền ngay, tiêu liền tay
            </div>
            <div>
                Vay tiền siêu tốc với FastMoney
            </div>
            <div class="mt-3 bg-content2-fm h-4/5">
                <div class="space-x-1">
                    <div class="inline-block">
                        <img  src="@/assets/default_main/ld_fm/icon_list.png"  alt="logo icon list white" /> 
                    </div>
                    <div class="inline-block">
                        Số tiền vay lên tới <span class="font-bold"> 20.000.000đ </span>    
                    </div> 
                </div>
                <div class="space-x-1">
                    <div class="inline-block">
                        <img  src="@/assets/default_main/ld_fm/icon_list.png"  alt="logo icon list white" /> 
                    </div>
                    <div class="inline-block">
                            Không chứng minh thu nhập   
                    </div> 
                </div>
                <div class="space-x-1">
                    <div class="inline-block">
                        <img  src="@/assets/default_main/ld_fm/icon_list.png"  alt="logo icon list white" /> 
                    </div>
                    <div class="inline-block">
                        Trả góp từng kỳ
                    </div> 
                </div>
                <div class="space-x-1">
                    <div class="inline-block">
                        <img  src="@/assets/default_main/ld_fm/icon_list.png"  alt="logo icon list white" /> 
                    </div>
                    <div class="inline-block">
                        Duyệt vay sau 3 phút 
                    </div> 
                </div>
                <div class="">
                    <img class="text-right" src="@/assets/default_main/ld_fm/money.png" alt="money image" />
                    <!-- <img class="float-right mr-10" src="@/assets/default_main/ld_fm/money.png" alt="money image" /> -->
                </div>

            </div>
        </div>
    </div>
  
</template>

<script>
export default {

}
</script>

<style>

</style>